import { c as _c } from "react-compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { AnalyticsContext } from "../AnalyticsProvider/AnalyticsProvider";
export const useAnalytics = () => {
  const $ = _c(7);
  const context = useContext(AnalyticsContext);
  if (!context) {
    throw new Error("useAnalytics must be used within AnalyticsProvider");
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["analytics", "anonymous-id"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== context) {
    t1 = {
      queryKey: t0,
      queryFn: async () => {
        const anonymousId = await context.getAnonymousId();
        return anonymousId ?? null;
      },
      staleTime: 120000
    };
    $[1] = context;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getAnonymousId = useQuery(t1);
  let t2;
  if ($[3] !== context || $[4] !== getAnonymousId.data || $[5] !== getAnonymousId.isLoading) {
    t2 = {
      ...context,
      anonymousId: getAnonymousId.data,
      isAnonymousIdLoading: getAnonymousId.isLoading
    };
    $[3] = context;
    $[4] = getAnonymousId.data;
    $[5] = getAnonymousId.isLoading;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};